import { useState } from "react";
import { ButtonOrLink } from "../../../design-system/primitives/components/ButtonOrLink/ButtonOrLink";
import Text from "../../../design-system/primitives/components/Text/Text";
import { icons } from "../../../design-system/primitives/icons";
import type { HandbookVideo } from "../../../api/handbook";
import HandbookVideoDialog from "./HandbookVideoDialog";
import styles from "./HandbookVideos.css";

const PlayIcon = icons["monitor-play"];

const VIMEO_SHARE_URL = /vimeo\.com\/(\d+)\/([0-9a-zA-Z]+)/;

const getVideoPoster = (url: string) => {
  const match = url.match(VIMEO_SHARE_URL);
  if (!match) return null;
  return `${import.meta.env.VITE_API_HOST}/video-poster/img?service=vimeo&id=${match[1]}&hash=${match[2]}`;
};

type Props = {
  videos: HandbookVideo[];
};

const HandbookVideos = ({ videos }: Props) => {
  const [selectedVideo, setSelectedVideo] = useState<HandbookVideo | null>(
    null,
  );

  return (
    <>
      <div className={styles.grid}>
        {videos.map((video) => {
          const poster = video.thumbnailUrl ?? getVideoPoster(video.url);

          return (
            <div key={video.key} className={styles.card}>
              <ButtonOrLink
                type="button"
                className={styles.preview}
                aria-label={`${video.title} abspielen`}
                onClick={() => setSelectedVideo(video)}
              >
                {poster && (
                  <img
                    className={styles.poster}
                    src={poster}
                    crossOrigin="use-credentials"
                    loading="lazy"
                    decoding="async"
                    alt=""
                  />
                )}
                <span className={styles.playIcon} aria-hidden>
                  <PlayIcon size={32} />
                </span>
              </ButtonOrLink>
              <div className={styles.body}>
                <Text variant="subheader-small">{video.title}</Text>
                {video.description && (
                  <Text variant="body" color="neutral-100">
                    {video.description}
                  </Text>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {selectedVideo && (
        <HandbookVideoDialog
          video={selectedVideo}
          onClose={() => setSelectedVideo(null)}
        />
      )}
    </>
  );
};

export default HandbookVideos;
